import CloseIcon from "@mui/icons-material/Close";
import { Grid, Paper } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";
import * as React from "react";
import { connect } from "react-redux";
import { LabelCompo } from "../../components/Comman/Label";
import DynamicTable from "../../components/Comman/RT/MaterialUIRTTable";
import { ButtonCompo } from "../../components/Comman/Button";
import DynamicDetails from "../../components/dynamicscreens/DynamicDetails";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const BootstrapDialogTitle = (props) => {
  const { classes, children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

const MRPConfigTable = ({
  handleCloses,
  open,
  columns,
  rows,
  onFormSave,
  categoryName = "",
  subCategoryName = "",
  publishDate = "",
}) => {
  const handleClose = () => {
    handleCloses();
  };

  return (
    <>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        fullWidth
        maxWidth="lg"
      >
        <BootstrapDialogTitle
          id="customized-dialog-title"
          onClose={handleClose}
        >
          MRP Configration
        </BootstrapDialogTitle>
        <DialogContent dividers>
          <DynamicDetails DataToSet={[
            {
              xs: 12,
              sm: 6,
              md: 6,
              lg: 6,
              labelXS: 12,
              labelSM: 3,
              labelMD: 3,
              labelLG: 3,
              valueXS: 12,
              valueSM: 9,
              valueMD: 9,
              valueLG: 9,
              label: "Category",
              value: categoryName,
            },
            {
              xs: 12,
              sm: 6,
              md: 6,
              lg: 6,
              labelXS: 12,
              labelSM: 4,
              labelMD: 4,
              labelLG: 4,
              valueXS: 12,
              valueSM: 8,
              valueMD: 8,
              valueLG: 8,
              label: "Publish Date",
              value: publishDate,
            }
          ]} />


          <DynamicTable
            data={rows}
            tableHead={columns}
            showPegination={false}
            isActionColActive={false}
          />
          <br />
          <Grid
            item
            sm={12}
            xs={12}
            md={12}
            lg={12}
            container
            justifyContent="right"
          >
            <ButtonCompo
              size="medium"
              type="submit"
              variant="contained"
              name={"Submit"}
              onClick={onFormSave}
            />
            &nbsp; &nbsp;
            <ButtonCompo
              size="medium"
              type="button"
              variant="outlined"
              name="Cancel"
              onClick={handleClose}
            />
          </Grid>
        </DialogContent>
      </BootstrapDialog>
    </>
  );
};
const mapStateToProps = (state) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(MRPConfigTable);
